var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { AzureThemeLight } from "@fluentui/azure-themes";
import { ThemeProvider } from "@fluentui/react";
import { DetailsListStyles, DetailsRowStyles } from "./UIProvider/DetailsList/DetailsListStyles";
var ThemeManager = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j;
    var children = _a.children;
    var isMobile = function () { return window.matchMedia && window.matchMedia("(max-width: 480px)").matches; };
    var appliedTheme = {};
    if (!isMobile())
        appliedTheme.components = {
            TextField: (_b = AzureThemeLight.components) === null || _b === void 0 ? void 0 : _b.TextField,
            ComboBox: (_c = AzureThemeLight.components) === null || _c === void 0 ? void 0 : _c.ComboBox,
            Dropdown: (_d = AzureThemeLight.components) === null || _d === void 0 ? void 0 : _d.Dropdown,
            CommandBar: (_e = AzureThemeLight.components) === null || _e === void 0 ? void 0 : _e.CommandBar,
            SearchBox: (_f = AzureThemeLight.components) === null || _f === void 0 ? void 0 : _f.SearchBox,
            DetailsList: (_g = AzureThemeLight.components) === null || _g === void 0 ? void 0 : _g.DetailsList,
            DetailsRow: (_h = AzureThemeLight.components) === null || _h === void 0 ? void 0 : _h.DetailsRow,
            DatePicker: (_j = AzureThemeLight.components) === null || _j === void 0 ? void 0 : _j.DatePicker,
        };
    // console.log(AzureThemeLight.components)
    appliedTheme.components.CommandBar.styles = CommandBarStyles;
    appliedTheme.components.DetailsList.styles = DetailsListStyles;
    appliedTheme.components.DetailsRow.styles = DetailsRowStyles;
    appliedTheme.defaultFontStyle = { fontFamily: 'Poppins' };
    return (_jsx(ThemeProvider, __assign({ theme: appliedTheme }, { children: children })));
};
var CommandBarStyles = function (props) {
    var theme = props.theme;
    var semanticColors = theme.semanticColors;
    var extendedSemanticColors = semanticColors;
    return {
        root: [
            {
                backgroundColor: semanticColors.bodyBackground,
                height: '36px',
                borderRadius: '0.25rem',
                borderBottomColor: extendedSemanticColors.commandBarBorder,
                paddingLeft: '0.25rem',
            },
        ],
    };
};
var TextFieldStyles = function (props) {
    var focused = props.focused, disabled = props.disabled, hasErrorMessage = props.hasErrorMessage, multiline = props.multiline, theme = props.theme;
    var semanticColors = theme.semanticColors;
    var extendedSemanticColors = semanticColors;
    return {
        fieldGroup: [
            !multiline && {
                height: '40px',
            },
            !hasErrorMessage && {
                borderColor: semanticColors.inputBorder,
                selectors: {
                    '::after': {
                        borderColor: extendedSemanticColors.controlFocus,
                    },
                },
            },
            !focused &&
                !disabled && {
                selectors: {
                    ':hover': {
                        borderColor: semanticColors.inputText,
                    },
                },
            },
            focused && {
                borderColor: semanticColors.focusBorder,
            },
            disabled && {
                borderColor: extendedSemanticColors.textFieldBorderDisabled,
                backgroundColor: semanticColors.primaryButtonBackgroundDisabled,
            },
            hasErrorMessage && [
                {
                    borderWidth: '1px',
                },
                focused && {
                    borderColor: semanticColors.focusBorder,
                    selectors: {
                        '&:focus, &:hover': {
                            borderColor: semanticColors.focusBorder,
                        },
                    },
                },
            ],
        ],
        icon: {
            bottom: 2,
        },
        prefix: {
            fontSize: theme.fonts.medium.fontSize,
        },
        suffix: {
            fontSize: theme.fonts.medium.fontSize,
        },
        field: [
            {
                color: semanticColors.inputText,
                backgroundColor: extendedSemanticColors.controlBackground,
                fontSize: theme.fonts.medium.fontSize,
                selectors: {
                    '::placeholder': {
                        color: semanticColors.inputPlaceholderText,
                        fontStyle: 'italic',
                    },
                    ':-ms-input-placeholder': {
                        color: semanticColors.inputPlaceholderText,
                        fontStyle: 'italic',
                    },
                    '::-webkit-input-placeholder': {
                        color: semanticColors.inputPlaceholderText,
                        fontStyle: 'italic',
                    },
                },
            },
            disabled && {
                color: semanticColors.primaryButtonTextDisabled,
                backgroundColor: semanticColors.primaryButtonBackgroundDisabled,
                selectors: {
                    '::placeholder': {
                        color: semanticColors.disabledBodyText,
                    },
                    ':-ms-input-placeholder': {
                        color: semanticColors.disabledBodyText,
                    },
                    '::-webkit-input-placeholder': {
                        color: semanticColors.disabledBodyText,
                    },
                },
            },
        ],
        errorMessage: {
            color: semanticColors.errorText,
        },
    };
};
export default ThemeManager;
